/*
 * Filename: cq-header.ts
 * Description:Common header for the app
 */

import React from 'react';
import Cookies from 'universal-cookie';
import { useHistory } from 'react-router-dom';
import { CQAppConstant } from '../../app-constants';
import './cq-header.css';
import CQ_Logo from '../../assets/images/logo.png';
import ProfileImg from '../../assets/images/avatar2.jpg';
import { CQAPIService } from '../../services/http-api.service';
import { observer } from 'mobx-react';


const CQLightningStudioHeader = () => {
  const cookie = new Cookies();
  const cqAPIService = new CQAPIService();
  const history = useHistory();
  const logout = async () => {
    try {
      const token = cookie.get(CQAppConstant.JWT_KEY);
      cookie.remove(CQAppConstant.JWT_KEY);
      cookie.remove(CQAppConstant.INSTANCE_URL);
      cookie.remove(CQAppConstant.VERSION_NUMBER);
      cookie.remove(CQAppConstant.LOGGED_IN_USERNAME);
      cookie.remove(CQAppConstant.LOGGED_IN_ORG_NAME_SPACE);
      history.push(CQAppConstant.NAVIGATION.DEFAULT_PATH);
      await cqAPIService.logout(token);
      cookie.remove(CQAppConstant.LOGIN_URL);
    } catch (error) {
      
    }
  };
  return (
    <header>
      <div className="slds-grid slds-grid_align-spread slds-p-around_medium">
        <div className="slds-global-header__logo">
          <img src={CQ_Logo} alt="Logo" />
        </div>
        <div className="slds-global-header__item slds-p-right_none">
          <div className="slds-grid sld-grid-align_center">

            <button className="slds-button slds-global-actions__avatar slds-global-actions__item-action" title="person name" aria-haspopup="true">
              <span className="slds-avatar slds-avatar_circle slds-avatar_medium" >
                <img alt="Person name" src={ProfileImg} title="User avatar" />
              </span>
            </button>
            <p className="slds-text-heading_medium slds-p-horizontal_small">{cookie.get(CQAppConstant.LOGGED_IN_USERNAME)}</p>
            <button className="slds-button slds-button_neutral" onClick={() => { logout(); }}>
              Log out
              <i className="slds-button__icon cq-icon-logout slds-button__icon_right"></i>
            </button>
          </div>
        </div>

      </div>
    </header>
  );
};

export default observer(CQLightningStudioHeader);


